import z from "zod";
export const DTOAuthClientSessionScope = z.object({
    workspaceId: z.string().optional(),
    designSystemIds: z.array(z.string()).optional(),
    contextId: z.string().optional(),
});
